import { z } from 'zod';
import { DATE_STRING_REGEX } from '../../utils/constants';
export const CreateUserAchievementV2Schema = z
    .object({
    name: z.string().max(255),
    description: z.string().optional().nullable(),
    startedOn: z.string().regex(DATE_STRING_REGEX).optional().nullable(),
    endedOn: z.string().regex(DATE_STRING_REGEX).optional().nullable(),
    type: z.enum(['projects', 'awards', 'conferences', 'bibliography'])
})
    .required();
//# sourceMappingURL=createUserAchievementV2Schema.js.map